import React, { useState } from "react";
import Modal from "react-modal";
import ModalContent from "./modal/ModalContent";

Modal.setAppElement("#root");

const valueContent = [
  {
    title: "Frontend Engineering",
    description: "Clean, scalable interfaces with React, TypeScript and maintainable component systems.",
  },
  {
    title: "Business Applications",
    description: "Internal tools, dashboards, forms and workflow automation for real business operations.",
  },
  {
    title: "AI Problem Solving",
    description: "Using AI for research, debugging, automation, content creation and faster execution.",
  },
  {
    title: "Product Development",
    description: "Turning rough ideas into useful features, MVPs and working software.",
  },
];

const About = () => {
  const [isOpen, setIsOpen] = useState(false);
  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  return (
    //    ABOUT
    <div className="edina_tm_about" id="about">
      <div className="container">
        <div className="about_title">
          <h3>About Me</h3>
        </div>
        <div className="content">
          <div
            className="leftpart"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-delay="100"
          >
            <div className="info">
              <h3>
                Hi, I'm <span>Bacim Boulehmi</span>
              </h3>
              <p>
                I'm a React Developer based in Hamburg, Germany, focused on building clean, scalable and business-oriented web applications.<br />

                I enjoy turning ideas into real products, from understanding the problem to designing useful interfaces and building maintainable frontend solutions. <br />

                I use AI effectively as a force multiplier to solve problems faster, from development and debugging to research, automation, content creation and turning rough ideas into working software.   
              </p>
            </div>
            <div className="my_skills">
              <h3 className="title">Where I create value</h3>
              <p className="desc">
                Frontend engineering, product thinking and practical AI problem solving.
              </p>
              <div className="wrapper">
                <div className="value_grid">
                  {valueContent.map((item) => (
                    <article className="value_item" key={item.title}>
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </article>
                  ))}
                </div>
              </div>
              <div className="edina_tm_button">
                <button
                  type="submit"
                  className="color"
                  onClick={toggleModalOne}
                >
                  More About Me
                </button>
              </div>
            </div>
          </div>
          {/* End leftpart */}

          <div className="rightpart">
            <div className="image">
              <img src="img/thumbs/26-35.jpg" alt="thumb" />

              <div
                className="main"
                style={{
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL + "img/about/bbacim.png"
                  })`,
                }}
                data-aos="fade-left"
                data-aos-duration="1200"
                data-aos-delay="200"
              ></div>

              <div
                className="experience"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="300"
              >
                <div className="info">
                  <h3>Business</h3>
                  <span>meets code</span>
                </div>
              </div>
            </div>
          </div>
          {/* End righttpart */}
        </div>
      </div>

      {/* Start About Details Modal */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal about-popup-wrapper"
        overlayClassName="custom-overlay "
        closeTimeoutMS={500}
      >
        <div className="edina_tm_modalbox">
          <button className="close-modal" onClick={toggleModalOne}>
            <img src="/img/svg/cancel.svg" alt="close icon" />
          </button>
          {/* End close icon */}

          <div className="box_inner">
            <div className="description_wrap scrollable">
              <ModalContent />                       
            </div>

          </div>
          {/* End box inner */}
        </div>
        {/* End modal box news */}
      </Modal>
      {/* End  About Details Modal */}
    </div>
    // /ABOUT
  );
};

export default About;
